import React, { Component } from "react";

import Api from "../../lib/componentApi";
import getCookie from "../../lib/getCookie";
import getBannerLinks from "../../lib/getBannerLinks";

export default class Banner extends Component {
  constructor(props) {
    super(props);
    const link = getBannerLinks(props.route);
    //eslint-disable-next-line
    const bannerCookie = (__isBrowser__ && getCookie("banner")) || null;
    this.state = { bannerCookie, link };
  }
  componentDidMount() {
    const { bannerCookie } = this.state;
    if (!bannerCookie) {
      var banner = document.getElementById("custom-smartbanner");
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var html = document.getElementById("static");
      var bannerText = document.getElementById("smartbanner-text");
      if (/android/i.test(userAgent)) {
        banner.classList.add("smartbanner-android");
        if (window.scrollY < 20){
          html.classList.add("smartbanner-show");
        }
        
        bannerText.innerHTML = "FREE - In Google Play";
        window.addEventListener("scroll", this.listenScrollEvent);
      } else if (/iPhone/.test(userAgent)) {
        banner.classList.add("smartbanner-ios");
        if (window.scrollY < 20){
          html.classList.add("smartbanner-show");
        }
        bannerText.innerHTML = "GET - On The App Store";
        window.addEventListener("scroll", this.listenScrollEvent);
      }
    }
  }
  listenScrollEvent = e => {
    e.preventDefault();
    if (document.getElementById("custom-smartbanner")) {
      var html = document.getElementById("static");
      var bodyHeight = document.body.offsetHeight - 70;

      if (bodyHeight <= window.innerHeight) {
        document.body.style.paddingBottom = '200px'
      }
      if (window && window.scrollY > 20) {
        if (html.classList.contains("smartbanner-show")) {
          html.classList.remove("smartbanner-show");
        }
      } else {
        if (!html.classList.contains("smartbanner-show")) {
          html.classList.add("smartbanner-show");
        }
      }
    }
  };
  closeBanner = () => {
    var html = document.getElementById("static");
    html.classList.remove("smartbanner-show");
    document.getElementById("custom-smartbanner").remove();
    Api.get("/api/close/banner", {}, (response, errors) => {
      if (errors) {
        console.log(errors);
      }
    });
  };
  render() {
    const { bannerCookie, link } = this.state;
    return (
      (bannerCookie && <div />) || (
        <div className="smartbanner visible-xs" id="custom-smartbanner">
          <div className="smartbanner-container">
            <a
              href="javascript:void(0);"
              className="smartbanner-close"
              onClick={this.closeBanner}
            >
              ×
            </a>
            <span
              className="smartbanner-icon"
              style={{ backgroundImage: "url(/png/application-icon.png)" }}
            />
            <div className="smartbanner-info">
              <div className="smartbanner-title">Local E: Food Delivery</div>
              <div>
                <img src="/svg/full-star.svg" />
                <img src="/svg/full-star.svg" />
                <img src="/svg/full-star.svg" />
                <img src="/svg/full-star.svg" />
                <img src="/svg/half-star.svg" />
                <span> (271)</span>
              </div>
              <span id="smartbanner-text" />
            </div>
            <a href={link} className="smartbanner-button">
              <span className="smartbanner-button-text">VIEW</span>
            </a>
          </div>
        </div>
      )
    );
  }
}
